import DailyReward from "@/components/DailyReward";
import IncomingMessage from "@/components/IncomingMessage";
import InstallAppDrawer from "@/components/InstallAppDrawer";
import Loading from "@/components/Loading";
import MobileNavigation from "@/components/MobileNavigation";
import RequestNotificationPermission from "@/components/RequestNotificationPermission";
import Sidebar from "@/components/Sidebar";
import { DEFAULT_USER_NAME } from "@/constants";
import AuthContext from "@/context/auth";
import SubscriptionModalContext from "@/context/modal";
import PlaylistContext from "@/context/playlist";
import usePolyfills from "@/libs/hooks/polyfills";
import { Box, Flex } from "@chakra-ui/react";
import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

const SemiProtectedLayout = () => {
  const { authLoaded, user } = useContext(AuthContext);
  const { getMaxHeightRepresentation } = usePolyfills();
  const { immersive } = useContext(PlaylistContext);
  const { isSubscriptionModalOpen } = useContext(SubscriptionModalContext);
  const maxH = getMaxHeightRepresentation();
  const hideNavigation = immersive || isSubscriptionModalOpen;

  // fallback UI when loading auth
  if (!authLoaded) return <Loading />;
  if (authLoaded && user && user.displayName === DEFAULT_USER_NAME)
    return <Navigate to="/auth/post-register" />;
  return (
    <>
      <Flex position="relative" bg="primary.100" minH={maxH}>
        <InstallAppDrawer />

        <DailyReward />
        <RequestNotificationPermission />
        <IncomingMessage />
        {/* 2025-08-04 nightco is not 18+ anymore */}
        {/* <R18Warning /> */}
        <Sidebar />
        <Box
          width={{ base: "100%", md: 640 }}
          mx="auto"
          px={0}
          pb={hideNavigation ? 0 : `${MobileNavigation.HEIGHT}px`}
        >
          <Outlet />
        </Box>
      </Flex>
      {!hideNavigation && <MobileNavigation />}
    </>
  );
};
export default SemiProtectedLayout;
